export default {
    FETCH_EDIT_HISTORY_FOR_CLIENT_REQUEST: "FETCH_EDIT_HISTORY_FOR_CLIENT_REQUEST",
    FETCH_EDIT_HISTORY_SUCCESS: "FETCH_EDIT_HISTORY_SUCCESS",
    FETCH_EDIT_HISTORY_FAILED: "FETCH_EDIT_HISTORY_FAILED",
    FETCH_ALL_EDIT_HISTORY_REQUEST: "FETCH_ALL_EDIT_HISTORY_REQUEST",
    FETCH_ALL_EDIT_HISTORY_SUCCESS: "FETCH_ALL_EDIT_HISTORY_SUCCESS"
};
